<script lang="tsx">
import { defineComponent, toRef, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Table, type TableColumnType } from 'ant-design-vue'
import { FormItem } from '-/Common/Form'
import { InputRmb } from '-/Common/Input'
import { getRequiredRule } from '@/constant/form'
import { genHouseDemolitionStandardDataSource } from '../../tools'
const [name] = createNamespace('HouseDemolitionCompStandardForm')
export default defineComponent({
  name,
  props: {
    dataSync: {
      type: Object as PropType<Partial<ApiJtProj.CompStandardData>>
    },
    prefix: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
  setup(props) {
    const genFormItemName = (key: string) => [...props.prefix, key]
    const columns: TableColumnType[] = [
      {
        title: '类别',
        dataIndex: 'type',
        width: 300,
        customRender({ text }) {
          return <span innerHTML={text}></span>
        }
      },
      {
        title: '单位',
        dataIndex: 'unit',
        width: 50,
        customRender() {
          return '平方米'
        }
      },
      {
        title: '标准(元/单位)',
        dataIndex: 'standard',
        width: 150,
        customRender({ record }) {
          return (
            <FormItem name={genFormItemName(record.key)} rules={getRequiredRule(`${record.type}标准`)}>
              <InputRmb v-model:value={data.value[record.key]} style='width: 100%' />
            </FormItem>
          )
        }
      }
    ]
    const data = toRef(props, 'dataSync', {})
    const dataSource = genHouseDemolitionStandardDataSource(data.value)
    return () => <Table pagination={false} columns={columns} dataSource={dataSource} size='small' />
  }
})
</script>
